(() => {
  if (window.__omStickyPurchaseV1Initialized) return;
  window.__omStickyPurchaseV1Initialized = true;

  const MOBILE_QUERY = "(max-width: 749px)";
  const PRODUCT_SELECTOR = "product-info[id^='MainProduct-']";
  const INFO_SELECTOR = ".product__info-container";
  const ADD_SELECTOR =
    'product-form button[name="add"], product-form .product-form__submit';
  const QUANTITY_SELECTOR = ".product-form__quantity .quantity__input";
  const SIZE_DIRECT_SELECTOR = "[data-om-size-option]";
  const STICKY_VALIDATED_ATTRIBUTE = "data-om-sticky-validated";

  const mobile = window.matchMedia(MOBILE_QUERY);
  let productInfo = null;
  let scope = null;
  let originalAdd = null;
  let originalQuantity = null;
  let sizeControl = null;
  let ui = null;
  let sheet = null;
  let sheetOptions = [];
  let frame = null;
  let returnFocus = null;
  let addInFlight = false;
  let addUnlockTimer = null;

  const icon = {
    minus:
      '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 10h12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    plus: '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="M10 4v12M4 10h12" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>',
    chevron:
      '<svg class="om-sticky-purchase__chevron" viewBox="0 0 16 16" aria-hidden="true"><path d="m4 6 4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    close:
      '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="m5 5 10 10M15 5 5 15" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>',
  };

  function createInterface() {
    if (ui) return;

    ui = document.createElement("aside");
    ui.className = "om-sticky-purchase";
    ui.setAttribute("aria-label", "Purchase options");
    ui.innerHTML = `
      <div class="om-sticky-purchase__row">
        <button class="om-sticky-purchase__size" type="button" data-om-sticky-size aria-haspopup="dialog" aria-controls="OmStickySizeSheet">
          <span class="om-sticky-purchase__size-label">Size</span>
          <span class="om-sticky-purchase__size-value" data-om-sticky-size-value>Select</span>
          ${icon.chevron}
        </button>
        <div class="om-sticky-purchase__quantity" data-om-sticky-quantity role="group" aria-label="Quantity">
          <button class="om-sticky-purchase__quantity-button" type="button" data-om-sticky-quantity-action="minus" aria-label="Decrease quantity">${icon.minus}</button>
          <span class="om-sticky-purchase__quantity-value" data-om-sticky-quantity-value aria-live="polite">1</span>
          <button class="om-sticky-purchase__quantity-button" type="button" data-om-sticky-quantity-action="plus" aria-label="Increase quantity">${icon.plus}</button>
        </div>
        <button class="om-sticky-purchase__add" type="button" data-om-sticky-add>
          <span data-om-sticky-add-label>Add to cart</span>
        </button>
      </div>`;

    sheet = document.createElement("div");
    sheet.id = "OmStickySizeSheet";
    sheet.className = "om-sticky-size-sheet";
    sheet.setAttribute("aria-hidden", "true");
    sheet.innerHTML = `
      <button class="om-sticky-size-sheet__backdrop" type="button" data-om-sticky-sheet-close tabindex="-1" aria-label="Close size selector"></button>
      <section class="om-sticky-size-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="OmStickySizeSheetTitle" tabindex="-1">
        <div class="om-sticky-size-sheet__handle" aria-hidden="true"></div>
        <header class="om-sticky-size-sheet__header">
          <h2 class="om-sticky-size-sheet__title" id="OmStickySizeSheetTitle">Choose size</h2>
          <button class="om-sticky-size-sheet__close" type="button" data-om-sticky-sheet-close aria-label="Close size selector">${icon.close}</button>
        </header>
        <div class="om-sticky-size-sheet__options" data-om-sticky-size-options></div>
        <p class="om-sticky-size-sheet__note">Unavailable sizes are crossed out.</p>
      </section>`;

    document.body.append(ui, sheet);

    ui.querySelector("[data-om-sticky-size]").addEventListener(
      "click",
      openSizeSheet,
    );
    ui.querySelector("[data-om-sticky-add]").addEventListener(
      "click",
      handleAdd,
    );
    ui.querySelectorAll("[data-om-sticky-quantity-action]").forEach(
      (button) => {
        button.addEventListener("click", () => {
          changeQuantity(button.dataset.omStickyQuantityAction);
        });
      },
    );
    sheet.querySelectorAll("[data-om-sticky-sheet-close]").forEach((button) => {
      button.addEventListener("click", closeSizeSheet);
    });
  }

  function refreshSources() {
    productInfo = document.querySelector(PRODUCT_SELECTOR);
    scope = productInfo?.querySelector(INFO_SELECTOR) || null;
    originalAdd = scope?.querySelector(ADD_SELECTOR) || null;
    originalQuantity = scope?.querySelector(QUANTITY_SELECTOR) || null;
    sizeControl = findSizeControl(scope);
  }

  function findSizeControl(container) {
    if (!container) return null;

    const direct = container.querySelector(SIZE_DIRECT_SELECTOR);
    if (direct) return direct;

    const fieldsets = Array.from(
      container.querySelectorAll("variant-selects fieldset"),
    );
    const sizeFieldset = fieldsets.find((fieldset) => {
      const legend = fieldset.querySelector("legend")?.textContent || "";
      return /\bsize\b/i.test(legend);
    });
    if (sizeFieldset) return sizeFieldset;

    return (
      Array.from(container.querySelectorAll("variant-selects select")).find(
        (select) => {
          const label = select.labels?.[0]?.textContent || "";
          return /\bsize\b/i.test(`${select.name} ${label}`);
        },
      ) || null
    );
  }

  function getSizeSources() {
    if (!sizeControl) return [];

    if (sizeControl.matches("select")) {
      return Array.from(sizeControl.options).map((option) => ({
        element: option,
        label: option.textContent.trim(),
        value: option.value,
        selected: option.selected,
        unavailable:
          option.disabled || /unavailable|sold out/i.test(option.textContent),
        type: "option",
      }));
    }

    return Array.from(sizeControl.querySelectorAll('input[type="radio"]')).map(
      (input) => ({
        element: input,
        label: input.value,
        value: input.value,
        selected: input.checked,
        unavailable:
          input.disabled ||
          input.classList.contains("disabled") ||
          input.getAttribute("aria-disabled") === "true" ||
          input.dataset.variantAvailable === "false",
        type: "radio",
      }),
    );
  }

  function getSelectedSize() {
    if (scope?.dataset.omSelectedSizeLabel) {
      return scope.dataset.omSelectedSizeLabel;
    }

    return getSizeSources().find((item) => item.selected)?.value || "";
  }

  function needsSize() {
    if (scope?.dataset.omPurchaseState === "needs-size") return true;

    const productForm = scope?.querySelector(
      "product-form[data-om-size-required]",
    );
    if (productForm?.dataset.omSizeRequired !== "true") return false;

    return !(
      scope?.dataset.omSelectedSizeId ||
      scope?.dataset.omSelectedSizeLabel ||
      getSelectedSize()
    );
  }

  function getNativeProductForm() {
    return (
      originalAdd?.form ||
      originalAdd?.closest("form") ||
      scope?.querySelector('form[data-type="add-to-cart-form"]') ||
      null
    );
  }

  function hasLiveVariant() {
    const form = getNativeProductForm();
    const variantInput = form?.querySelector('[name="id"]');

    return Boolean(
      form &&
        variantInput &&
        !variantInput.disabled &&
        String(variantInput.value || "").trim(),
    );
  }

  function unlockAdd() {
    addInFlight = false;
    window.clearTimeout(addUnlockTimer);
    addUnlockTimer = null;
    requestSync();
  }

  function renderSizeOptions() {
    const optionsRoot = sheet?.querySelector("[data-om-sticky-size-options]");
    if (!optionsRoot) return;

    const sources = getSizeSources();
    sheetOptions = sources;
    optionsRoot.replaceChildren();

    sources.forEach((item, index) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = "om-sticky-size-sheet__option";
      button.textContent = item.label;
      button.disabled = item.unavailable;
      button.classList.toggle("is-selected", item.selected);
      button.classList.toggle("is-unavailable", item.unavailable);
      button.setAttribute("aria-pressed", item.selected ? "true" : "false");
      if (item.unavailable)
        button.setAttribute("aria-label", `${item.label}, unavailable`);
      button.addEventListener("click", () => selectSize(index));
      optionsRoot.append(button);
    });
  }

  function selectSize(index) {
    const item = sheetOptions[index];
    if (!item || item.unavailable) return;

    if (item.type === "radio") {
      item.element.click();
    } else if (sizeControl) {
      sizeControl.value = item.value;
      sizeControl.dispatchEvent(new Event("change", { bubbles: true }));
    }

    closeSizeSheet();
    requestSync();
    window.setTimeout(requestSync, 180);
  }

  function openSizeSheet() {
    refreshSources();
    renderSizeOptions();
    if (!sheetOptions.length) return;

    returnFocus = document.activeElement;
    sheet.classList.add("is-open");
    sheet.setAttribute("aria-hidden", "false");
    document.body.classList.add("om-sticky-size-sheet-open");
    requestSync();

    window.requestAnimationFrame(() => {
      const target =
        sheet.querySelector(".om-sticky-size-sheet__option.is-selected") ||
        sheet.querySelector(".om-sticky-size-sheet__option:not(:disabled)") ||
        sheet.querySelector(".om-sticky-size-sheet__close");
      target?.focus({ preventScroll: true });
    });
  }

  function closeSizeSheet() {
    if (!sheet?.classList.contains("is-open")) return;

    sheet.classList.remove("is-open");
    sheet.setAttribute("aria-hidden", "true");
    document.body.classList.remove("om-sticky-size-sheet-open");
    returnFocus?.focus?.({ preventScroll: true });
    returnFocus = null;
    requestSync();
  }

  function changeQuantity(action) {
    refreshSources();
    if (!originalQuantity) return;

    const button = originalQuantity
      .closest("quantity-input")
      ?.querySelector(`button[name="${action}"]`);

    if (button && !button.disabled) {
      button.click();
      requestSync();
      return;
    }

    const current = Number(originalQuantity.value || 1);
    const step = Number(originalQuantity.step || 1);
    const minimum = Number(originalQuantity.min || 1);
    const maximum = originalQuantity.max
      ? Number(originalQuantity.max)
      : Number.POSITIVE_INFINITY;
    const next = action === "plus" ? current + step : current - step;
    const clamped = Math.min(maximum, Math.max(minimum, next));

    if (clamped === current) return;
    originalQuantity.value = String(clamped);
    originalQuantity.dispatchEvent(new Event("change", { bubbles: true }));
    requestSync();
  }

  function handleAdd() {
    refreshSources();

    if (addInFlight) return;

    if (needsSize()) {
      openSizeSheet();
      return;
    }

    if (scope?.dataset.omPurchaseState === "pending") {
      requestSync();
      return;
    }

    if (
      !originalAdd ||
      originalAdd.disabled ||
      originalAdd.getAttribute("aria-disabled") === "true" ||
      !hasLiveVariant()
    ) {
      requestSync();
      return;
    }

    addInFlight = true;
    originalAdd.setAttribute(STICKY_VALIDATED_ATTRIBUTE, "true");

    try {
      originalAdd.click();
    } finally {
      originalAdd.removeAttribute(STICKY_VALIDATED_ATTRIBUTE);
      requestSync();
    }

    window.clearTimeout(addUnlockTimer);
    addUnlockTimer = window.setTimeout(unlockAdd, 900);
  }

  function syncQuantity() {
    const wrapper = ui.querySelector("[data-om-sticky-quantity]");
    const value = ui.querySelector("[data-om-sticky-quantity-value]");
    const minus = ui.querySelector('[data-om-sticky-quantity-action="minus"]');
    const plus = ui.querySelector('[data-om-sticky-quantity-action="plus"]');

    wrapper.hidden = !originalQuantity;
    if (!originalQuantity) return;

    const current = Number(originalQuantity.value || 1);
    const step = Number(originalQuantity.step || 1);
    const minimum = Number(originalQuantity.min || 1);
    const maximum = originalQuantity.max
      ? Number(originalQuantity.max)
      : Number.POSITIVE_INFINITY;

    value.textContent = originalQuantity.value || "1";
    minus.disabled = current - step < minimum;
    plus.disabled = current + step > maximum;
  }

  function syncSize() {
    const button = ui.querySelector("[data-om-sticky-size]");
    const value = ui.querySelector("[data-om-sticky-size-value]");
    const selected = getSelectedSize();

    button.hidden = !sizeControl || getSizeSources().length === 0;
    value.textContent = selected || "Select";
    button.classList.toggle(
      "needs-selection",
      Boolean(sizeControl && !selected),
    );

    if (sheet?.classList.contains("is-open")) renderSizeOptions();
  }

  function syncAdd() {
    const button = ui.querySelector("[data-om-sticky-add]");
    const label = ui.querySelector("[data-om-sticky-add-label]");
    const sizeRequired = needsSize();
    const loading =
      addInFlight ||
      originalAdd?.classList.contains("loading") ||
      originalAdd?.getAttribute("aria-busy") === "true";
    const pending = scope?.dataset.omPurchaseState === "pending";
    const unavailable =
      !sizeRequired &&
      !loading &&
      !pending &&
      (!originalAdd ||
        originalAdd.disabled ||
        originalAdd.getAttribute("aria-disabled") === "true" ||
        !hasLiveVariant());

    button.classList.toggle("is-size-required", sizeRequired);
    button.classList.toggle("is-loading", loading || pending);

    if (sizeRequired) {
      label.textContent = "Choose size";
      button.disabled = false;
    } else if (loading || pending) {
      label.textContent = loading ? "Adding…" : "Checking…";
      button.disabled = true;
    } else if (unavailable) {
      const sourceText = originalAdd?.querySelector("span")?.textContent.trim();
      label.textContent = sourceText || "Sold out";
      button.disabled = true;
    } else {
      label.textContent = window.variantStrings?.addToCart || "Add to cart";
      button.disabled = false;
    }
  }

  function blockingInterfaceOpen() {
    return Boolean(
      document.querySelector(
        ".section-header details[open], " +
          "cart-drawer .drawer.active, " +
          "cart-notification .cart-notification.active, " +
          "#cart-notification.active, " +
          ".search-modal[open], " +
          "product-modal[open], product-modal.active, " +
          "details-modal[open], " +
          ".om-size-confirmation.is-open, " +
          "[data-om-size-confirmation].is-open",
      ),
    ) || document.body.classList.contains("om-size-confirmation-open");
  }

  function sourceAddVisible() {
    if (!originalAdd?.isConnected) return false;

    const rect = originalAdd.getBoundingClientRect();
    const viewportHeight =
      window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth;

    return (
      rect.bottom > 0 &&
      rect.top < viewportHeight &&
      rect.right > 0 &&
      rect.left < viewportWidth
    );
  }

  function syncVisibility() {
    const sheetOpen = sheet.classList.contains("is-open");
    const visible =
      mobile.matches &&
      !sourceAddVisible() &&
      !sheetOpen &&
      !blockingInterfaceOpen();

    ui.classList.toggle("is-visible", visible);
    document.body.classList.toggle("om-sticky-purchase-visible", visible);
  }

  function sync() {
    frame = null;
    refreshSources();
    if (!productInfo || !scope || !originalAdd) {
      ui?.classList.remove("is-visible");
      document.body.classList.remove("om-sticky-purchase-visible");
      return;
    }

    syncSize();
    syncQuantity();
    syncAdd();
    syncVisibility();
  }

  function requestSync() {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(sync);
  }

  function trapSheetKeyboard(event) {
    if (!sheet?.classList.contains("is-open")) return;

    if (event.key === "Escape") {
      event.preventDefault();
      closeSizeSheet();
      return;
    }

    if (event.key !== "Tab") return;
    const focusable = Array.from(
      sheet.querySelectorAll(
        'button:not(:disabled), [href], [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((element) => element.offsetParent !== null);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function observeDynamicState() {
    const productObserver = new MutationObserver(requestSync);
    if (productInfo) {
      productObserver.observe(productInfo, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: [
          "disabled",
          "aria-disabled",
          "aria-busy",
          "checked",
          "class",
          "value",
        ],
      });
    }

    const interfaceObserver = new MutationObserver(requestSync);
    document
      .querySelectorAll(
        ".section-header, cart-drawer, cart-notification, product-modal, details-modal",
      )
      .forEach((element) => {
        interfaceObserver.observe(element, {
          subtree: true,
          attributes: true,
          attributeFilter: ["class", "open"],
        });
      });

    interfaceObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  function initialize() {
    createInterface();
    refreshSources();
    if (!productInfo) return;

    observeDynamicState();
    window.addEventListener("scroll", requestSync, { passive: true });
    window.addEventListener("resize", requestSync, { passive: true });
    document.addEventListener("change", requestSync, true);
    document.addEventListener("input", requestSync, true);
    document.addEventListener("toggle", requestSync, true);
    document.addEventListener("keydown", trapSheetKeyboard);
    document.addEventListener("product-info:loaded", requestSync);
    document.addEventListener("shopify:section:load", requestSync);

    if (mobile.addEventListener) {
      mobile.addEventListener("change", requestSync);
    } else {
      mobile.addListener(requestSync);
    }

    requestSync();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
